import { useState, useEffect } from 'react';
import { useLostPets } from './useLostPets';

const LAST_VISIT_KEY = 'lost-pets-last-visit';

export const useLostPetsBadge = () => {
  const [newCount, setNewCount] = useState(0);
  const { data: lostPets } = useLostPets();

  useEffect(() => {
    if (!lostPets) return;

    const lastVisit = localStorage.getItem(LAST_VISIT_KEY);
    const lastVisitDate = lastVisit ? new Date(lastVisit) : new Date(0);

    const newPets = lostPets.filter(pet => 
      new Date(pet.created_at) > lastVisitDate
    );

    setNewCount(newPets.length);
  }, [lostPets]);

  const markAsVisited = () => {
    localStorage.setItem(LAST_VISIT_KEY, new Date().toISOString());
    setNewCount(0);
  };

  return { newCount, markAsVisited };
};
